
(function (window, document, jQuery, undefined) {
    // map jQuery to local var
    var $ = jQuery.noConflict();

    function setSameHeight() {
        var $body = $('body');

        // get lists
        var $gridCardsList = $(".don-grid-cards--same-height");

        // set same height of cards in one list
        $gridCardsList.each(function () {
            var $list = $(this);

            // clear height styles and find max heights
            var maxCardHeight = 0;
            var $gridCards = $list.find('.don-grid-cards__card');

            $gridCards.each(function () {
                var $gridCard = $(this);

                $gridCard.removeAttr('style');

                maxCardHeight = $gridCard.height() > maxCardHeight ? $gridCard.height() : maxCardHeight;
            });

            // skip if xs
            if (!$body.hasClass('is-sm')) {
                return;
            }

            // set max heights
            $gridCards.each(function () {
                $(this).height(maxCardHeight);
            });
        })
    }

    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            setSameHeight();
        }, 200);
    });

    $(document).ready(setSameHeight);
})(window, document, jQuery);
